import { SessionContext } from '@contexts';
import { useContext } from 'react';

export const useSession = () => {
    return useContext(SessionContext);
}